export default __webpack_public_path__ + "static/media/arrow-right.e2a9f4b7.svg";